import { Archivable, Creatable, Modifiable } from 'model/business-base';
import { HolidayTrip } from 'model/forms/holiday-trip';
import { EntityBase } from 'model/platform-types';

export abstract class HolidayTripDetailApi {
  abstract getHolidayTrip(id: number): Promise<HolidayTripDetail>;
  abstract createHolidayTrip(holidayTrip: HolidayTrip): Promise<HolidayTripDetail>;
  abstract updateHolidayTrip(id: number, holidayTrip: HolidayTrip): Promise<HolidayTripDetail>;
  abstract archiveHolidayTrip(id: number): Promise<HolidayTripDetail>;
  abstract restoreHolidayTrip(id: number): Promise<HolidayTripDetail>;
}

export interface HolidayTripDetail {
  data: HolidayTripData;
  permissions: HolidayTripPermissions;
}

export interface HolidayTripData extends HolidayTrip, EntityBase, Creatable, Modifiable, Archivable {
  // ...
}

export interface HolidayTripPermissions {
  canEdit: boolean;
  canArchive: boolean;
  canRestore: boolean;
}
